<div class="page-section">
  <div class="section-content">
    <div class="text">
      <h1>Grade Smarter. Maximize Value</h1>

      <p>
        The Card Professor offers a revolutionary new process to maximize the
        potential value and aesthetic presentation of your collection.
      </p>
    </div>

    <img id="hero-image" src="assets/images/hero-image.png" />
  </div>
</div>

<div id="divider"></div>
